module.exports = __webpack_public_path__ + "img/img5-3.e36c39c8.jpg";